export const CURRENCIES = [
    { code: 'USD', symbol: '$', name: 'US Dollar', usdRate: 1.00 },
    { code: 'EUR', symbol: '€', name: 'Euro', usdRate: 1.04 },
    { code: 'GBP', symbol: '£', name: 'British Pound', usdRate: 1.26 },
    { code: 'JPY', symbol: '¥', name: 'Japanese Yen', usdRate: 0.0067 },
    { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar', usdRate: 0.74 },
    { code: 'AUD', symbol: 'A$', name: 'Australian Dollar', usdRate: 0.65 },
    { code: 'CHF', symbol: 'Fr', name: 'Swiss Franc', usdRate: 1.12 },
    { code: 'CNY', symbol: '¥', name: 'Chinese Yuan', usdRate: 0.14 },
    { code: 'INR', symbol: '₹', name: 'Indian Rupee', usdRate: 0.012 },
    { code: 'BRL', symbol: 'R$', name: 'Brazilian Real', usdRate: 0.20 },
    { code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar', usdRate: 0.61 },
    { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar', usdRate: 0.74 },
    { code: 'HKD', symbol: 'HK$', name: 'Hong Kong Dollar', usdRate: 0.13 },
    { code: 'SEK', symbol: 'kr', name: 'Swedish Krona', usdRate: 0.096 },
    { code: 'KRW', symbol: '₩', name: 'South Korean Won', usdRate: 0.00075 },
    { code: 'MXN', symbol: 'Mex$', name: 'Mexican Peso', usdRate: 0.059 },
    { code: 'ZAR', symbol: 'R', name: 'South African Rand', usdRate: 0.053 },
    { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham', usdRate: 0.27 },
    { code: 'RUB', symbol: '₽', name: 'Russian Ruble', usdRate: 0.011 },
    { code: 'PLN', symbol: 'zł', name: 'Polish Złoty', usdRate: 0.25 }
];

// Helper function to get symbol from currency code
export const getCurrencySymbol = (code) => {
    const currency = CURRENCIES.find(c => c.code === code);
    return currency?.symbol || '$'; // Default to $ if not found
};

// Create a simple mapping object for quick lookups
export const CURRENCY_SYMBOLS = CURRENCIES.reduce((acc, curr) => {
    acc[curr.code] = curr.symbol;
    return acc;
}, {}); 

// Helper function to convert between currencies
export const convertCurrency = (amount, fromCurrency, toCurrency) => {
    const fromRate = CURRENCIES.find(c => c.code === fromCurrency)?.usdRate || 1;
    const toRate = CURRENCIES.find(c => c.code === toCurrency)?.usdRate || 1;
    return (amount * fromRate) / toRate;
}; 